document.addEventListener('DOMContentLoaded', () => {
  const desktop = () => window.matchMedia('(min-width: 990px)').matches;
  const detailsEls = document.querySelectorAll('header-menu details.mega-menu');
  if (!detailsEls.length) return;

  const closeAll = () => {
    detailsEls.forEach(d => {
      d.classList.remove('is-clicked');
      d.removeAttribute('open');
    });
  };

  detailsEls.forEach(d => {
    const summary = d.querySelector(':scope > summary.header__menu-item');
    if (!summary) return;

    // Klik (og tastatur) åbner/lukker
    const toggleByUser = (e) => {
      if (!desktop()) return;
      e.preventDefault(); // vi håndterer åbne/lukke selv

      const isOpenAndClicked = d.hasAttribute('open') && d.classList.contains('is-clicked');
      closeAll();
      if (!isOpenAndClicked) {
        d.classList.add('is-clicked');
        d.setAttribute('open', '');
      }
    };

    summary.addEventListener('click', toggleByUser);
    summary.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') toggleByUser(e);
    });
  });

  // Luk ved klik udenfor og ved breakpoint-skift
  document.addEventListener('click', (e) => {
    if (desktop() && !e.target.closest('header-menu')) closeAll();
  });
  window.matchMedia('(min-width: 990px)').addEventListener('change', closeAll);
});
